import RequestManager from "../requests/RequestManager";
import PlayerTracks from "../requests/tasks/music/PlayerTracks";
import store from "../store";

class PlayerTracksUtil {
  getPlayerTracks(type, idAlbum) {
    let cm_access_token = "";
    const _cm = store.getState().user;
    if(_cm.musicUser && _cm.musicUser.cm_access_token) {
      cm_access_token = _cm.musicUser.cm_access_token;
    }
    const params = {
      method: "GET",
      payload: { list_id: idAlbum, type: type },
    };
    params.cm_access_token = cm_access_token;
    const musicTask = new PlayerTracks("playerTracks", params, null);

    return RequestManager.addRequest(musicTask);
  }
}

export default PlayerTracksUtil;



// WEBPACK FOOTER //
// ./src/utils/PlayerTracksUtils.js